import { useState } from 'react';
import { RefreshCw, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { FlexibleTracking } from './FlexibleTracking';
import { GeneralList2PriceMismatch } from './GeneralList2PriceMismatch';
import { generalList2Service } from '../services/generalList2Service';

export function GeneralList2() {
  const [backfilling, setBackfilling] = useState(false);
  const [includeLocked, setIncludeLocked] = useState(false);
  const [activeTab, setActiveTab] = useState<'fleet' | 'price-mismatch'>('fleet');

  const handleBackfill = async () => {
    if (!confirm('Tüm sevkiyatların yükleme/teslim noktaları metinleri yeniden hesaplanacak. Devam edilsin mi?')) return;
    try {
      setBackfilling(true);
      const result: any = await generalList2Service.syncPointsText();
      toast.success(result?.message || 'Nokta bilgileri güncellendi');
    } catch (err: any) {
      toast.error(err?.message || 'Güncelleme başarısız');
    } finally {
      setBackfilling(false);
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-2 px-4 py-1 bg-white border-b border-gray-200">
        <button type="button" onClick={() => setActiveTab('fleet')} className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold ${activeTab === 'fleet' ? 'border-orange-300 bg-orange-50 text-orange-700' : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'}`}>
          Filo Durum Listesi
        </button>
        <button type="button" onClick={() => setActiveTab('price-mismatch')} className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold ${activeTab === 'price-mismatch' ? 'border-rose-300 bg-rose-50 text-rose-700' : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'}`}>
          Uyumsuz Fiyatlar
        </button>
        {activeTab === 'fleet' ? (
          <button
            type="button"
            onClick={() => void handleBackfill()}
            disabled={backfilling}
            className="inline-flex items-center gap-1.5 rounded-lg border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-700 hover:bg-amber-100 disabled:opacity-50"
          >
            {backfilling ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
            {backfilling ? 'Güncelleniyor...' : 'Noktaları Güncelle'}
          </button>
        ) : null}
        <label className="ml-2 inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-medium text-slate-700">
          <input
            type="checkbox"
            checked={includeLocked}
            onChange={(event) => setIncludeLocked(event.target.checked)}
            className="h-4 w-4 rounded border-slate-300 text-amber-600 focus:ring-amber-500"
          />
          Kilitli kayıtları getir
        </label>
      </div>
      <div className="flex-1 min-h-0">
        {activeTab === 'fleet' ? (
          <FlexibleTracking
            key={includeLocked ? 'fleet-status-list-with-locked' : 'fleet-status-list-without-locked'}
            dataService={generalList2Service}
            dataParams={{ includeLocked }}
            settingsKeyScope="general_list_2_fleet"
            title="Filo Durum Listesi"
            subtitle="Çekici, dorse ve sürücü bilgilerini öne çıkaran ayrı backend endpointli görünüm."
            constrainTableToViewport
            defaultVisibleColumns={[
              'archiveCode',
              'folderNumber',
              'evrakSiraNo',
              'invoiceNumber',
              'cekici',
              'dorse',
              'surucuAdi',
              'surucuKonumu',
              'surucuSonKonum',
              'surucuTelefon',
              'surucuGunlukSureKalani',
              'surucuHaftalikSureKalani',
              'surucuIkiHaftalikSureKalani',
              'gunlukKm',
              'tcKimlikNo',
              'durum',
              'islemDurum',
              'nearestHub',
              'accountingStatus',
              'operasyonNot',
              'yuklemeTarihi',
              'aracAtamaTarihi',
               'activeShipmentCount',
               'teslimNoktasiSayisi',
               'ugrmaSayisi',
               'bazFiyat',
               'hedefFiyat',
               'durakBedeli',
               'updatedAt',
              'lkm',
            ]}
          />
        ) : (
          <GeneralList2PriceMismatch includeLocked={includeLocked} />
        )}
      </div>
    </div>
  );
}
